import { render, staticRenderFns } from "./PopupInformativo.vue?vue&type=template&id=9ffd8628&scoped=true"
import script from "./PopupInformativo.vue?vue&type=script&lang=js"
export * from "./PopupInformativo.vue?vue&type=script&lang=js"
import style0 from "./PopupInformativo.vue?vue&type=style&index=0&id=9ffd8628&prod&lang=css"
import style1 from "./PopupInformativo.vue?vue&type=style&index=1&id=9ffd8628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ffd8628",
  null
  
)

export default component.exports